import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'src/rerouter/index';
import {useApi} from 'src/hooks/useApi';
import {Loading} from 'src/components/lib/loading/index';
import {CONSTANTS} from 'src/components/authentication/contants';
import {TitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './phone-deregistration.css';

import {resetPhoneApprove} from 'src/action-creators/authentication';

import {
  selectResetPhoneApproveError,
  selectResetPhoneApproved,
} from 'src/selectors/authentication';


export const ApprovePhoneReset = (): React.ReactElement<
  React.ComponentProps<'div'>
> => {
  const {makeKey, t} = useLabelTranslation();
  const {token} = useParams();
  const dispatch = useDispatch();
  const apiError = useSelector(selectResetPhoneApproveError);
  const apiResponse = useSelector(selectResetPhoneApproved);
  const handlePhoneResetApproval = async () => {
    await dispatch(resetPhoneApprove(token));
  };
  const successMessage =
    t('Reset_phone_number_for', 'Reset phone number for') + ' ' + apiResponse;
  handlePhoneResetApproval();
  return (
    <div className={css.mainContainer}>
      <div className={css.container}>
        {apiError ? (
          <TitleMedium>{t(makeKey(apiError), apiError)}</TitleMedium>
        ) : (
          <TitleMedium>{successMessage}</TitleMedium>
        )}
      </div>
    </div>
  );
};
